<template>
<div class="custom  d-inline">
<bee-date-label v-if="readonly && insideTable" :date="value ? formatDate() : emptyState"></bee-date-label>
<div class="FormDate" v-else>
    <input
		:disabled="disabled"
		:readonly="readonly"
		v-if="showDay"
		ref="day"
		v-model="day"
		class="FormDate__input FormDate__input--day"
		type="number"
		placeholder="dd"
		@input="updateDay"
		@blur="day = day.toString().padStart(2, 0)"
		@keypress="$emit('keypress', $event)"
		@keydown.enter="$emit('keydown-enter-prevent')"
		@keydown.esc.prevent="$emit('keydown-esc-prevent')"
		@keydown.ctrl.down="$emit('keydown-ctrl-down')">
    <span
		v-if="showDay && showMonth"
		class="FormDate__divider"
    >-</span>
    <input
		:disabled="disabled"
		:readonly="readonly"
		v-if="showMonth"
		ref="month"
		v-model="month"
		class="FormDate__input FormDate__input--month"
		type="number"
		placeholder="mm"
		@input="updateMonth"
		@blur="month = month.toString().padStart(2, 0)"
		@keypress="$emit('keypress', $event)"
		@keydown.enter="$emit('keydown-enter-prevent')"
		@keydown.esc.prevent="$emit('keydown-esc-prevent')"
		@keydown.ctrl.down="$emit('keydown-ctrl-down')">
    <span
		v-if="showYear && (showDay || showMonth)"
		class="FormDate__divider"
    >-</span>
    <input
		:disabled="disabled"
		:readonly="readonly"
		v-if="showYear"
		ref="year"
		v-model="year"
		class="FormDate__input FormDate__input--year"
		type="number"
		placeholder="yyyy"
		@input="updateYear"
		@blur="handleBlurYear; $emit('blur', $event);"
		@keypress="$emit('keypress', $event)"
		@keydown.enter="$emit('keydown-enter-prevent')"
		@keydown.esc.prevent="$emit('keydown-esc-prevent')"
		@keydown.tab="$emit('keydown-tab')"
		@keydown.ctrl.down="$emit('keydown-ctrl-down')">
</div>
</div>
</template>

<script>
export default {
name: `BeeDateField`,
props: {
    value: {
		type: [Number, String],
    },
    showDay: {
		type: Boolean,
		default: true,
    },
    showMonth: {
		type: Boolean,
		default: true,
    },
    showYear: {
		type: Boolean,
		default: true,
	},
	readonly: {
		type: Boolean,
		default: false,
	},
	dense: {
		type: Boolean,
		default: false,
	},
	emptyState: {
		type: String,
		default: "-",
	},
	insideTable: {
		type: Boolean,
		default: false,
	},
	disabled: {
		type: Boolean,
		default: false,
	},
  },
data() { 
	return{
	day: `${this.value ? new Date(this.value).getDate() : new Date().getDate()}`,
		// Get the month as a number (0-11)
	month: `${this.value ? new Date(this.value).getMonth() + 1 : new Date().getMonth() + 1}`,
		// Get the year as a four digit number (yyyy)
	year: `${this.value ? new Date(this.value).getFullYear(): new Date().getFullYear()}`,
}},
watch: {
    year(current, prev) {

		if (current > 9999) this.year = prev;
		this.updateValue()
    },
    month() {
		this.updateValue()
    },
    day() {
		this.updateValue()
    },
	value() {
		// to make sure that the inputs has the same component value
		this.day = `${this.value ? new Date(this.value).getDate() : new Date().getDate()}`,
		this.month = `${this.value ? new Date(this.value).getMonth() + 1 : new Date().getMonth() + 1}`,
		this.year = `${this.value ? new Date(this.value).getFullYear(): new Date().getFullYear()}`
	}
},
computed: {
	valid() {
		return Number(this.year) > 0 && Number(this.month) > 0 && Number(this.day) > 0
	}
},
methods: {
	focus() {
		this.$refs.day.select();
	},
	validate() {
		return this.valid;
	},
	resetValidation() {},
	
	/* eslint-disable */

	formatDate(){
		let d = new Date(this.value),
        month = (d.getMonth() + 1).toString().padStart(2, 0),
        day =  d.getDate().toString().padStart(2, 0),
        year = d.getFullYear().toString().padStart(4, 0);
    	return [year, month, day].join('/');
	},

	DaysInMonth(month,year) {
		 let _month= parseInt(month) ; 
		 let _year= parseInt(year) ; 
		return new Date(_year, _month, 0).getDate();
	},
	
    updateDay(e,isOuterCall=false) {
	
		const day_int=parseInt(this.day);
		let _month=parseInt(this.month);

		if(!isOuterCall)
		if( [2,4,6,9,11].includes(_month)){  // 2 4 6 9 11 less than or qual max day =30
			if(day_int==31){
				while(this.DaysInMonth(++_month,this.year)!=31){}
				this.month = _month;
			} 
			if(_month==2 && day_int==30 )
				this.month = _month+1;
		}
		const daysInMonth=this.DaysInMonth(this.month,this.year);
		//const daysInLeftMonth = this.DaysInMonth(parseInt(this.month)-1,this.year);  // we can use for auto calculate month and days
		if(day_int == 0) this.day = daysInMonth;
		
		if(day_int > daysInMonth ){
			this.day = 1;
			if(isOuterCall)
				this.day = daysInMonth; // keep max days in month when down mothes liek  month-3 down to month-2 when day is 31 should be 28 not from 1
		}

	

		// this.day=this.day.toString().padStart(2, 0);
    },
    updateMonth() {
		const month_int=parseInt(this.month);
		const monthsInYear = 12;

		if(month_int == 0) this.month = monthsInYear;
		if(month_int > monthsInYear ) this.month = 1;

	//	this.month=this.month.toString().padStart(2, 0);

		//update day
		if(this.month)
		this.updateDay({},true);


    },
	updateYear(){
		const year_int=parseInt(this.year);
		const maxYear = 9999;
		const miniYear = 1753;

		if(year_int == miniYear) this.year = 0;
		if(year_int > maxYear ) this.year = maxYear;	
		//this.year=this.year.toString().padStart(4, 0);
		if(this.year)
		if(this.month!="00")
		this.updateDay({},true); // update moth to update day 
	},
	handleBlurYear()
	{
		const year_int=parseInt(this.year);
		const miniYear = 1753;
		if(year_int < miniYear) this.year = miniYear;
		this.year = this.year.toString().padStart(4, 0);
	},
    updateValue() {
		const timestamp = Date.parse(`${this.year.toString().padStart(4, 0)}-${this.month}-${this.day} Z`);
		if (Number.isNaN(timestamp)) return;
		this.$emit(`input`, new Date(timestamp).toISOString());
		this.$emit('change', new Date(timestamp).toISOString());
		
		if (!this.dense) this.$emit('blur');
    },

	/* eslint-disable */

},
mounted(){
	if(!this.readonly && !this.value)
	this.$emit('input', new Date().toISOString())
}
};
</script>

<style lang="scss">
.FormDate:focus-within {
  border-bottom: 2px solid #346f86 !important;
}
.FormDate {
  $spacing: 0em;
  display: inline-flex;
  position: relative;
  overflow: hidden;
  padding: 3px 0;
  border-bottom: 1px solid #999;
  // 1. Hide the spinner button in Chrome, Safari and Firefox.
  &__input {
    padding: $spacing;
    padding-right: $spacing / 2;
    padding-left: $spacing / 2;
    border: none;
    text-align: center;
    /* stylelint-disable-next-line property-no-vendor-prefix */
    -moz-appearance: textfield; // 1
    &::-webkit-inner-spin-button {
      display: none; // 1
    }
    &:first-child {
      padding-left: $spacing;
    }
    &:last-child {
      padding-right: $spacing;
    }
    &:focus {
      outline: none;
    }
    &--day,
    &--month {
      width: 1.2em;
    }
    &--year {
      width: 2.2em;
    }
  }
  &__divider {
    padding-top: $spacing;
    padding-bottom: $spacing;
    pointer-events: none;
  }
}
</style>
<style>
.custom input {
    caret-color: auto !important;
    font-family: Calibri !important;
    font-weight: 550 !important;
    font-size: 1.05rem !important;
}
</style>